import { Component, Inject, OnInit, Renderer2, ViewChild, ElementRef, HostListener, NgZone, AfterViewInit } from '@angular/core';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { Router, RouterModule } from '@angular/router';
import { NgForm, FormsModule } from '@angular/forms';
import { CommonModule, Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import { SharedModeService } from '../../shared/services/shared-mode.service';
import { AddService } from 'src/app/shared/services/userservices/add.service'
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

declare let $: any;
@Component({
  selector: 'app-team-management',
  templateUrl: './team-management.component.html',
  styleUrl: './team-management.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule],
})
export class TeamManagementComponent implements AfterViewInit, OnInit {

  loannotification: any = {};
  lonecount: any;

  activeTab = 'user-list';
  isTeamView = false;
  employeeTab: 'current' | 'ex' = 'current';
  // isCurrentEmployee: boolean = true;
  // isoldEmployee: boolean = false;
  public showSpinner = true;
  usersList: any;
  departmentuserSRole: any[] = [];
  card_name: any;
  userRolesArray: any[] = [];
  department: any;
  user: any;
  departmentNames: any;
  toggleUserId: any;
  userNameForModal: any;
  toggleUserStatus: any = 1;
  wfhModalValueTracker = false;
  selectedUserFor2FA: any;
  intended2FAStatus = false;
  toggleRef2FA: HTMLInputElement | null = null;
  selectedMode: any;
  userInfo: any;
  colormode: any;
  isExEmployeeLoaded: any;
  oldUsersList: any;
  departmentNames1: any;
  seleted_user: any;
  statuses: any;
  isStatusForEditLoaded = false;
  selectedUserUUID: any;
  apidata: any;
  uuid: any;
  showDropdown = false;
  selectedDate = '';
  showError = false;

  constructor(
    private renderer: Renderer2,
    private http: HttpClient,
    public _location: Location,
    public dashboardService: DashboardService,
    public router: Router,
    private sharedmode: SharedModeService,
    private elementRef: ElementRef,
    private ngZone: NgZone,
    @Inject(AddService) private addService: AddService,
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');

    this.user_detail();
    
  }

  ngOnInit(): void {
    this.getData();

    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }

  removed(removed: any) {
    throw new Error('Method not implemented.');
  }



  UserRetrived() {
    this.seleted_user.uuid
    this.showSpinner = true;
    this.addService.retrivedUser(this.seleted_user.uuid).then((value) => {
      this.showSpinner = false;
      window.location.reload();
    });
  }


  getstatusData() {

    if (!this.isStatusForEditLoaded) {
      this.showSpinner = true
      this.addService.getStaticData().then((value) => {
        this.showSpinner = false;
        this.statuses = value.data.employeeTypes;
        this.isStatusForEditLoaded = true;
      })
    }

  }

  getUserdata(uuid: any) {
    this.getstatusData();

    this.selectedUserUUID = uuid;
    this.addService.updateUser(uuid).then((value) => {
      this.apidata = value?.data

    });

  }
  filteredUsersList: Record<string, any[]> = {}; // Filtered data
  searchTerm = '';
  getData(department = '', page = 1) {
    this.showSpinner = true;

    this.dashboardService.getUserList().then((value) => {
      if (value.success == true) {

        this.usersList = value.data;
        this.filteredUsersList = JSON.parse(JSON.stringify(this.usersList)); // copy for filtering
        this.departmentNames = Object.keys(this.usersList);
        for (const departmentName in this.usersList) {
          if (this.usersList.hasOwnProperty(departmentName)) {
            const usersInDepartment = this.usersList[departmentName];
            usersInDepartment.sort(compareUsers);

            this.departmentuserSRole = [];

            // Process users in the department

            for (const user of usersInDepartment) {
              try {
                // if (user?.user_role != undefined || user?.user_role != null) {

                //   }
                if (user?.user_role?.user_roles) {
                  const userRoles = JSON.parse(user.user_role.user_roles);
                  this.departmentuserSRole.push(userRoles.role_type);
                }
                // this.card_name = user.card_name;
                // user.backgroundImage = this.getBackgroundImage(user.department, user.card_name);
              } catch (error) {
                console.error("Error parsing user roles:", error);
              }
            }
            this.userRolesArray.push(this.departmentuserSRole);
          }
        }

        // Define the User interface
        interface User {
          id: number;
          first_name: string;
          last_name: string;
          user_roles: string;
          card_name: string;
          backgroundImage?: string;
        }

        // Function to compare users based on their role_type
        function compareUsers(a: User, b: User): number {
          const roleOrder = ["Admin_AND_Team_Lead", "Admin", "Team_Lead", "Employee"];
          const roleA = a.user_roles ? JSON.parse(a.user_roles).role_type : "Employee";
          const roleB = b.user_roles ? JSON.parse(b.user_roles).role_type : "Employee";
          const indexA = roleOrder.indexOf(roleA);
          const indexB = roleOrder.indexOf(roleB);

          if (indexA === -1 && indexB === -1) {
            return roleA.localeCompare(roleB);
          }
          if (indexA === -1) {
            return 1;
          }
          if (indexB === -1) {
            return -1;
          }
          return indexA - indexB;
        }

        this.showSpinner = false;

      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });


  }






  hasCrown(user: any): boolean {
    if (!user.user_role || !user.user_role.user_roles) {
      return false;
    }

    let roles: any;

    try {
      // Parse JSON string into an object
      roles = JSON.parse(user.user_role.user_roles);
    } catch (e) {
      console.error('Invalid JSON in user_roles', e);
      return false;
    }

    const roleType = roles.role_type;
    return ['Admin', 'Team_Lead', 'Admin_AND_Team_Lead'].includes(roleType);
  }



  // filter search
  filterUsers() {
    const term = this.searchTerm.toLowerCase();

    if (!term) {
      // Reset to original data if search is empty
      this.filteredUsersList = JSON.parse(JSON.stringify(this.usersList));
      return;
    }

    const filtered: Record<string, any[]> = {};

    this.departmentNames.forEach((dept: any) => {
      const filteredUsers = this.usersList[dept].filter((user: any) =>
        `${user.first_name} ${user.last_name}`.toLowerCase().includes(term) ||
        user.email?.toLowerCase().includes(term) ||
        user.department?.toLowerCase().includes(term)
      );
      if (filteredUsers.length > 0) {
        filtered[dept] = filteredUsers;
      }
    });

    this.filteredUsersList = filtered;
  }

  convertTo12Hour(time: string): string {
    this.showSpinner = true;

    if (time) {
      const [hours, minutes] = time.split(':').map(Number);
      const ampm = hours >= 12 ? 'PM' : 'AM';

      const adjustedHours = hours % 12 || 12; // convert 0 to 12 for 12 AM/PM
      this.showSpinner = false;

      return `${adjustedHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
    }
    this.showSpinner = false;

    return "00:00"; // default value for null or invalid time

  }


  // getBackgroundImage(department: string, cardName: string): string {
  //   // Check if cardName has a specific image
  //   if (this.cardImageMappings[cardName]) {
  //     return this.cardImageMappings[cardName];
  //   }
  //   // Default background image based on department
  //   return this.departmentBackgrounds[department] || '';
  // }

  addNewUserBtn() {
    this.router.navigate(['/employee-add']);
  }

  deleteModal(user: any) {
    this.seleted_user = user
    const modalDiv = document.getElementById('deleteModal');
    if (modalDiv != null) {
      modalDiv.style.display = 'block';
    }

  }

  UserDelete() {

    this.seleted_user.uuid
    this.showSpinner = true;
    this.addService.deleteUser(this.seleted_user.uuid).then((value) => {
      this.showSpinner = false;
      window.location.reload();
    });
  }


  retrivedModal(user: any) {
    this.seleted_user = user
    const modalDiv = document.getElementById('retrivedModal');
    if (modalDiv != null) {
      modalDiv.style.display = 'block';
    }

  }


  UserUpdate(uuid: string) {
    this.router.navigate(['/employee-add/', uuid]);
    this.addService.updateUser(uuid).then((value) => {
    });
  }



  setUserUUID(uuid: string) {
    this.selectedUserUUID = uuid;
  }


  isavailablefeature(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.team_managment?.data?.values;
    switch (type) {
      case "isView":
        return values.view ?? false
      case "isAddUser":
        return values.add ?? false
      case "isMothySalary":
        return values.monthly_salary ?? false
      case "isDeleteUser":
        return values.delete ?? false
      case "isUpdateUser":
        return values.updateUser ?? false
      case "isloanReport":
        return values.loanView ?? false
      case "isWFH":
        return values.update ?? false
      case "isReset":
        return values.reset2fa ?? false
      case "isAction":
        return values.action2fa ?? false
      case "isTeamlead":
        return !(this.user.department == 'Team Leads' ? true : false)
      default:
        return false;
    }
    return false
  }


  updateStatus(statusUpdate: NgForm) {
    this.uuid = this.apidata.uuid

    const status = statusUpdate.value.employee_type
    this.addService.updateStatus(this.uuid, status).then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'User Status Updated Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }



  updatePassword(passwordUpdate: NgForm) {
    this.uuid = this.selectedUserUUID
    const password = passwordUpdate.value.password
    this.addService.updatePassword(this.uuid, password).then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'User Password Updated Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }

  updateShiftTime(ShiftTimeUpdate: NgForm) {
    this.uuid = this.selectedUserUUID
    const startTime = ShiftTimeUpdate.value.startTime
    const endTime = ShiftTimeUpdate.value.endTime
    this.addService.updateShiftTime(this.uuid, startTime, endTime).then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'User Shift Time Updated Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });

  }

  updateAccount(accountUpdate: NgForm) {
    this.uuid = this.selectedUserUUID
    const accountNo = accountUpdate.value.ac_number
    this.addService.updateAccountNo(this.uuid, accountNo).then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'User Account No Updated Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }


  updateSalary(salaryUpdate: NgForm) {
    this.uuid = this.selectedUserUUID
    const salary = salaryUpdate.value.newSalary
    const taxSalary = salaryUpdate.value.salaryTax
    this.addService.updateSalary(this.uuid, salary, taxSalary).then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'User Salary Updated Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }


  getWFH(userId: any, userStatus: Event, tracker: any) {
    this.dashboardService.getWFH(userId, userStatus, tracker).then((response: any) => {
      if (response && response.success === true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: response.message,
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: `WFH update failed or was not successful`,
          showConfirmButton: false,
          timer: 3000,
        });
      }
      this.getData();
    }).catch(error => {
      console.error('Error in getWFH:', error);
    });
  }
  selectedUserId: number | null = null;
  lastToggleElement: HTMLInputElement | null = null;
  toggleValue = false;
  ngAfterViewInit() {
    $('#confirmModalss').on('hidden.bs.modal', () => {
      this.ngZone.run(() => {
        if (this.lastToggleElement) {
          // Revert the toggle
          this.lastToggleElement.checked = !this.toggleValue;
        }

        // Clear references
        this.lastToggleElement = null;
        this.selectedUserId = null;
      });
    });
  }

  toggleClick(user: any, event: Event, toggleRef: HTMLInputElement) {
    event.preventDefault();

    this.showSpinner = true;

    this.lastToggleElement = toggleRef;
    this.toggleUserId = user.id;
    this.userNameForModal = user.first_name + ' ' + user.last_name;
    // Detect current checked state
    const isChecked = toggleRef.checked;
    this.toggleValue = isChecked; // store current state for reference

    // Save intended WFH status
    this.toggleUserStatus = isChecked ? 1 : 0;

    // Set current Tracker value from user
    this.wfhModalValueTracker = user.tracker == 1 ? true : false;
    // Show modal
    this.showSpinner = false;
    setTimeout(() => {
      $('#confirmModalss').modal('show');
    }, 0);
    // $('#confirmModalss').modal('show');
  }

  modalClick(value: boolean) {
    this.showSpinner = true;

    const newStatus = this.toggleValue ? 1 : 0;

    if (value == true) {
      this.wfhModalValueTracker = value;

    } else {

      this.wfhModalValueTracker = value;
    }

    this.getWFH(this.toggleUserId, this.toggleUserStatus, this.wfhModalValueTracker);
    $('#confirmModalss').modal('hide');
    this.showSpinner = false;

  }
  modalClickChangeValues() {
    const newStatus = this.toggleValue ? 1 : 0;
    this.toggleUserStatus = 0;
    this.wfhModalValueTracker = false;

    this.getWFH(this.toggleUserId, this.toggleUserStatus, this.wfhModalValueTracker);
    $('#confirmModalss').modal('hide');
  }
  isWFHAllowed(user: any): boolean {
    const dayIndex = 0;
    if (user.todays_usershittime?.[dayIndex]?.work_from_home == '1' || (user.attandance_type != 'Normal')) {
      return true;
    }
    return false;
  }


  getolduser(removed: any) {
    if (!this.isExEmployeeLoaded) {
      this.showSpinner = true;
      removed = 1
      this.dashboardService.getOldList(removed).then((value) => {
        this.showSpinner = false;
        this.oldUsersList = value.data;
        this.isExEmployeeLoaded = true;
        this.filteredOldUsersList = JSON.parse(JSON.stringify(this.oldUsersList)); // copy for filtering

        this.departmentNames1 = Object.keys(this.oldUsersList);
        //     this.currentPage[department] = page;
        // this.totalPages[department] = value.totalPages;

        // Sort and process user roles

        for (const departmentName in this.oldUsersList) {
          if (this.oldUsersList.hasOwnProperty(departmentName)) {
            const usersInDepartment = this.oldUsersList[departmentName];
            usersInDepartment.sort(compareUsers);

            this.departmentuserSRole = [];
            // this.userRolesArray.push(this.departmentuserSRole);
          }
        }
        interface User {
          id: number;
          first_name: string;
          last_name: string;
          user_roles: string;
          card_name: string;
          backgroundImage?: string;
        }

        // Function to compare users based on their role_type
        function compareUsers(a: User, b: User): number {
          const roleOrder = ["Admin_AND_Team_Lead", "Admin", "Team_Lead", "Employee"];
          const roleA = a.user_roles ? JSON.parse(a.user_roles).role_type : "Employee";
          const roleB = b.user_roles ? JSON.parse(b.user_roles).role_type : "Employee";
          const indexA = roleOrder.indexOf(roleA);
          const indexB = roleOrder.indexOf(roleB);

          if (indexA === -1 && indexB === -1) {
            return roleA.localeCompare(roleB);
          }
          if (indexA === -1) {
            return 1;
          }
          if (indexB === -1) {
            return -1;
          }
          return indexA - indexB;
        }

      });
    }
  }
  filteredOldUsersList: Record<string, any[]> = {}; // Filtered data
  searchTermOld = '';
  // filter search
  filterOldUsers() {
    const term = this.searchTermOld.toLowerCase();

    if (!term) {
      // Reset to original data if search is empty
      this.filteredOldUsersList = JSON.parse(JSON.stringify(this.oldUsersList));
      return;
    }

    const filtered: Record<string, any[]> = {};

    this.departmentNames1.forEach((dept: any) => {
      const filteredUsers = this.oldUsersList[dept].filter((user: any) =>
        `${user.first_name} ${user.last_name}`.toLowerCase().includes(term) ||
        user.email?.toLowerCase().includes(term) ||
        user.department?.toLowerCase().includes(term)
      );
      if (filteredUsers.length > 0) {
        filtered[dept] = filteredUsers;
      }
    });

    this.filteredOldUsersList = filtered;
  }
  user_detail() {
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.user = this.userInfo 
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
    })

  }


  departmentBackgrounds: Record<string, string> = {
    'Higher Management': '../../../assets/images/test-bg.png',
    'Human Resource Managment': '../../../assets/images/s-bg.png',
    'Team Leads': '../../../assets/images/t-bg.png',
    'Business Development': '../../../assets/images/mobile-bg.png',
    'Web Application Development': '../../../assets/images/mobile-bg.png',
    'Mobile Application Development': '../../../assets/images/mobile-bg.png',
    'Graphic Designers': '../../../assets/images/mobile-bg.png',
    'Quality Insurance': '../../../assets/images/mobile-bg.png',
    'Demo Users': '../../../assets/images/mobile-bg.png',
    'Office Boys': '../../../assets/images/mobile-bg.png',
  };
  cardImageMappings: Record<string, string> = {
    'TEAM_LEAD_CARD': '../../../assets/user-cards/1.svg',
    'MANAGER_CARD': '../../../assets/user-cards/2.svg',
    'DEMO_CARD': '../../../assets/user-cards/3.svg',
    'HR_CARD': '../../../assets/user-cards/4.svg',
    'ADMIN_CARD': '../../../assets/user-cards/5.svg',
    'FACUTY_CARD': '../../../assets/user-cards/6.svg',
    'ADMIN_TEAM_LEAD_CARD': '../../../assets/user-cards/7.svg',
    'FACULTY_MANAGER_CARD': '../../../assets/user-cards/8.svg',
    'MANAGMENT_CARD': '../../../assets/user-cards/9.svg',
    'HUMAN_RESOURCE_CARD': '../../../assets/user-cards/10.svg',
    'SUPERADMIN_CARD': '../../../assets/user-cards/11.svg',
    'OFFICE_FACUTY_CARD': '../../../assets/user-cards/12.svg'
  };



  setTab(tab: string): void {
    this.activeTab = tab;

  }

  switchToExEmployees() {
    this.employeeTab = 'ex';
    this.getolduser(1); // You may replace `1` with your `removed` value
  }
  // showCurrentEmployee() {
  //   this.isCurrentEmployee = true;
  //   this.isoldEmployee = false;
  // }
  // // tabs funtion
  // showoldEmployee() {

  //   this.getolduser(this.removed);
  //   this.isCurrentEmployee = false;
  //   this.isoldEmployee = true;

  // }

  openedDropdownUserId: number | null = null;

  toggleDropdown(userId: number): void {
    this.openedDropdownUserId = this.openedDropdownUserId === userId ? null : userId;
  }

  closeDropdown(): void {
    this.openedDropdownUserId = null;
  }
  @HostListener('document:click')
  onDocumentClick(): void {
    if (this.openedDropdownUserId !== null) {
      this.closeDropdown();
    }
  }

  // account check
  restrictInputToAccounts(event: Event) {
    const input = event.target as HTMLInputElement;
    let inputValue = input.value;

    const modifiedValue = inputValue.replace(/[^0-9-]/g, '').replace(/-{2,}/g, '-');

    const firstHyphenIndex = modifiedValue.indexOf('-');
    const lastHyphenIndex = modifiedValue.lastIndexOf('-');

    if (firstHyphenIndex !== lastHyphenIndex) {
      const hyphenRemovedValue = modifiedValue.substring(0, lastHyphenIndex) +
        modifiedValue.substring(lastHyphenIndex + 1);
      inputValue = hyphenRemovedValue;
    } else {
      inputValue = modifiedValue;
    }

    if (inputValue !== input.value) {
      input.value = inputValue;
      input.dispatchEvent(new Event('input'));
    }
  }

  monthlySalary() {
    if (!this.selectedDate || this.selectedDate.length === 0) {
      this.showError = true;
      return;
    }
    // let selected_date = (<HTMLInputElement>document.getElementById("salary_month")).value;
    // if (selected_date == null || selected_date.length == 0) {
    //   return
    // }

    // this.router.navigate(['/employee-monthly-salary', { 'selected_date': selected_date }]);


    this.showError = false;

    // Navigate to salary page
    this.router.navigate(['/employee-monthly-salary', { 'selected_date': this.selectedDate }]);

    // Dismiss modal manually
    (document.querySelector('.modal.show') as any)?.classList.remove('show');
    (document.querySelector('.modal-backdrop') as any)?.remove();
    document.body.classList.remove('modal-open');



  }

  Loannotificaton(lonecount: any) {
    const user_role = JSON.parse(this.user.user_role.user_roles)

    if (user_role.role_type != "Team_Lead") {
      this.lonecount = "loan_request";
      this.addService.loanNotify(this.lonecount).then((value) => {

        this.loannotification = value.data
      })
    }
  }
  loanReport() {
    this.router.navigate(['/loan-report']);
  }
  showDetails(user: any) {
    const role = this.user.user_role.user_roles
    const userRoles = JSON.parse(role);
    const monthlySalary = userRoles.team_managment.data.values.view;
    if (monthlySalary == true) {
      // var name = user.first_name + " " + user.last_name
      // this.router.navigate(['/employee-payrolls-detail', { 'user_id': user.id, 'user_name': name, 'designation': user.description }]);
       this.router.navigate(['past-payroll'], {
      state: {
        user_id: user.id
      }
    });
    }

  }


  toggleDropdownanimation() {
    this.showDropdown = !this.showDropdown;
  }

  onAction(action: string) {
    this.showDropdown = false; // close dropdown after selection
  }

  showUserDetails(data: any) {
    const uuid = data.uuid
    if (uuid != '' && uuid != null && uuid != undefined) {
       this.router.navigate(
      ['/user-profile-view', uuid],
      { queryParams: { from: 'team-management' } }
    );
    }
  }

  // 2FA
   confirmReset2FA(user: any) {
    Swal.fire({
      title: `Reset 2FA for ${user.name}?`,
      html: `
        <p>Are you sure you want to reset Two-Factor Authentication for <strong>${user.name}</strong>?</p>
        <img src="../../../../assets/theme1/conformation.png" alt="image" >
      `,
      showCancelButton: true,
      confirmButtonText: 'Yes, Reset',
      cancelButtonText: 'Cancel',
      width: 400
    }).then((result) => {
      if (result.isConfirmed) {
        this.reset2FA(user.id);
      }
    });
  }

  reset2FA(userId: number) {
    this.dashboardService.reset2FAUser(userId).then((res: any) => {
      if (res.success) {
        Swal.fire({
          iconHtml: '<img src="../../../../assets/images/success-modal.svg" alt="image" >',
          title: res.message,
          showConfirmButton: false,
          timer: 3000
        });
      } else {
        Swal.fire({
          iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image" >',
          title: res.message,
          showConfirmButton: false,
          timer: 3000
        });
      }
    });
  }


  onTwoFactorClick(user: any, event: Event, toggleRef: HTMLInputElement) {
    event.preventDefault();
    this.selectedUserFor2FA = user;
    this.intended2FAStatus = toggleRef.checked;
    this.toggleRef2FA = toggleRef;
    this.userNameForModal = user.first_name + ' ' + user.last_name;

    // Show modal
    setTimeout(() => {
      $('#confirmModal2FA').modal('show');
    }, 0);
  }

  confirm2FAToggle() {
    const isEnabled = this.intended2FAStatus;
    const userId = this.selectedUserFor2FA?.id;

    this.showSpinner = true;
    this.dashboardService.enable2FAUser(userId, isEnabled)
      .then((res: any) => {
        this.showSpinner = false;
        if (res.success) {
          this.selectedUserFor2FA.auth_verify = isEnabled ? 1 : 0;
          if (this.toggleRef2FA) {
            this.toggleRef2FA.checked = isEnabled;
          }
          Swal.fire({
            iconHtml: '<img src="../../../../assets/images/success-modal.svg" alt="image">',
            title: res.message,
            showConfirmButton: false,
            timer: 3000
          });
        } else {
          // Revert toggle if failed
          if (this.toggleRef2FA) {
            this.toggleRef2FA.checked = !isEnabled;
          }
          Swal.fire({
            iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image">',
            title: res.message || 'Something went wrong',
            showConfirmButton: false,
            timer: 3000
          });
        }
      })
      .catch((err: any) => {
        this.showSpinner = false;
        // Revert toggle if error
        if (this.toggleRef2FA) {
          this.toggleRef2FA.checked = !isEnabled;
        }
        Swal.fire({
          iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image">',
          title: err.error?.message || 'Something went wrong',
          showConfirmButton: false,
          timer: 3000
        });
      });

    $('#confirmModal2FA').modal('hide');
  }

  cancel2FAToggle() {
    if (this.toggleRef2FA) {
      this.toggleRef2FA.checked = !this.intended2FAStatus;
    }
    $('#confirmModal2FA').modal('hide');
  }

  // Make your API call or update logic here

//  openPreview(user: any) {
//     this.router.navigate(['past-payroll'], {
//       state: {
//         user_id: user.id
//       }
//     });
//   }


// shift Time 
shiftData: {
  day: string;
  start: string | null;
  end: string | null;
  hours: number;
  wfh: boolean;
  off: boolean;
}[] = [
  { day: 'Monday', start: null, end: null, hours: 0, wfh: false, off: false },
  { day: 'Tuesday', start: null, end: null, hours: 0, wfh: false, off: false },
  { day: 'Wednesday', start: null, end: null, hours: 0, wfh: false, off: false },
  { day: 'Thursday', start: null, end: null, hours: 0, wfh: false, off: false },
  { day: 'Friday', start: null, end: null, hours: 0, wfh: false, off: false },
  { day: 'Saturday', start: null, end: null, hours: 0, wfh: false, off: false },
  { day: 'Sunday', start: null, end: null, hours: 0, wfh: false, off: false }
];
// Copy Monday to all
copyAll() {
  const source = this.shiftData[0];

  this.shiftData = this.shiftData.map((item, i) => {
    if (i === 0) return item;

    return {
      ...item,
      start: source.start,
      end: source.end,
      hours: source.hours,
      wfh: source.wfh,
      off: source.off
    };
  });
}

// Auto calculate hours
updateHours(index: number) {
  const shift = this.shiftData[index];

  if (shift.start && shift.end) {
    const start = new Date(`1970-01-01T${shift.start}`);
    const end = new Date(`1970-01-01T${shift.end}`);

    // If end is before start, it means the shift goes overnight
    if (end <= start) {
      end.setDate(end.getDate() + 1); // add 1 day to end
    }

    shift.hours = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
  }
}
toggleOffDay(index: number) {
  const shift = this.shiftData[index];

  if (shift.off) {
    // Clear start and end times properly
    shift.start = '';
    shift.end = '';
    shift.hours = 0;
    shift.wfh = false;
  }

  // Trigger Angular change detection
  this.shiftData = [...this.shiftData];
}

preparePayload() {
  const days = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];

  return days.map(day => {
    const shift = this.shiftData.find(s => s.day === day) || { start: null, end: null, hours: 0, wfh: false, off: true };

    return {
      day,
      shift_start_time: shift.off ? null : shift.start,
      shift_end_time: shift.off ? null : shift.end,
      total_working_hours: shift.off ? 0 : Number(shift.hours.toFixed(2)),
      wfh: shift.off ? false : shift.wfh,
      off_day: shift.off
    };
  });
}
saveShift() {
  debugger
  this.showSpinner = true;
  $('#shiftTime').modal('hide');
   this.showDropdown = false;
  const payload = this.preparePayload();
  this.dashboardService.setShiftTime(payload).then((res: any) => {
    this.showSpinner = false;

      if (res.success) {
        Swal.fire({
          iconHtml: '<img src="../../../../assets/images/success-modal.svg" alt="image" >',
          title: res.message,
          showConfirmButton: false,
          timer: 3000
        });
      } else {
        Swal.fire({
          iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image" >',
          title: res.message,
          showConfirmButton: false,
          timer: 3000
        });
      }
    });
}

}
